import classNames from 'classnames';
import React, { useState } from 'react';

import './SizeToContentsInput.scss';

export interface SizeToContentsInputProps {
    value: string;
    placeholder?: string;
    onValueChange: (nextValue: string) => void;
}

export function SizeToContentsInput(props: SizeToContentsInputProps) {
    const DefaultInputContentsWidth = 20;
    const InputWidthPadding = 5;
    const DefaultInputWidth = 147;

    const { value, placeholder, onValueChange } = props;

    const [inputContentsWidth, setInputContentsWidth] = useState(
        DefaultInputContentsWidth
    );

    const onSearchInputChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const { value } = event.target;
        const width = calculateInputWidth(event);
        setInputContentsWidth(width);
        onValueChange(value);
    };

    const hasValue = !!value;
    const inputWidth = hasValue
        ? inputContentsWidth + InputWidthPadding
        : DefaultInputWidth;
    const inputStyle = { width: inputWidth };

    return (
        <input
            className={classNames(
                'SizeToContentsInput',
                hasValue && 'has-value'
            )}
            type="text"
            placeholder={placeholder}
            onChange={onSearchInputChange}
            value={value}
            style={inputStyle}
        />
    );
}

function calculateInputWidth(
    event: React.ChangeEvent<HTMLInputElement>
): number {
    const { parentElement, value } = event.target;

    const span = document.createElement('span');
    span.className = 'BlotterToolbarHiddenSpan';
    span.innerText = value;
    parentElement!.appendChild(span);
    const width = span.offsetWidth;
    parentElement!.removeChild(span);
    return width;
}
